import { pushTo } from '@app/core/routing';
import { FeedItem } from '@knocklabs/client';
import { getNotificationItemActionUrlBlock } from '../feed/item/get-notification-item-action-url-block';
import { getNotificationWorkflow } from '../workflows';

function isHttpUrl(url: string): boolean {
  return url.startsWith('http://') || url.startsWith('https://');
}

/**
 * True when `openNotificationActionUrl` would open a new browser tab.
 */
export function opensNotificationActionInNewTab(url: string): boolean {
  return isHttpUrl(url);
}

/**
 * Resolves the navigation URL for a feed item from the workflow descriptor,
 * falling back to Knock's template `action_url` block.
 */
export function getNotificationActionUrl(item: FeedItem): string | null {
  const workflow = getNotificationWorkflow(item.source?.key);
  const data = (item.data ?? {}) as Record<string, unknown>;
  const fromWorkflow = workflow?.actionUrl(data) ?? null;
  return fromWorkflow ?? getNotificationItemActionUrlBlock(item);
}

/**
 * Opens an in-app path via the router, or an absolute http(s) URL in a new tab.
 */
export function openNotificationActionUrl(url: string): void {
  if (url.startsWith('/') && !url.startsWith('//')) {
    pushTo(url);
    return;
  }

  if (isHttpUrl(url)) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
